import styled from 'styled-components';

export const PageContainer = styled.div`
  padding: 0;
  max-width: 800px;
  margin: 0 auto;
  background-color: #f8f9fa;
  min-height: 100%;
  overflow-y: auto;
  position: relative;
  width: 100%;
  box-sizing: border-box;
  left: 0;
  right: 0;
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0;
  background-color: #2e5cb8;
  color: white;
  padding: 15px 20px;
`;

export const PageTitle = styled.h1`
  font-size: 18px;
  font-weight: 500;
  margin: 0;
  color: white;
`;

export const ContentSection = styled.div`
  margin-top: 0;
  padding: 20px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; /* For smooth scrolling on iOS */
  padding-bottom: 40px; /* Add extra padding at bottom for better scroll experience */
`;

export const ThankYouText = styled.div`
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 8px;
  text-align: center;
`;

export const OfficeInfo = styled.div`
  margin-top: 10px;
  color: #555;
  text-align: center;
  
  div:first-child {
    font-weight: 500;
  }
`;

export const Description = styled.p`
  margin-top: 15px;
  color: #666;
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
`;

export const RatingGroup = styled.div`
  margin-top: 25px;
  padding: 15px;
  border-radius: 8px;
  background-color: white;
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
`;

export const RatingTitle = styled.div`
  display: flex;
  align-items: center;
`;

export const IconWrapper = styled.div`
  margin-right: 10px;
  display: flex;
  align-items: center;
  color: #1976d2;
`;

export const RatingTitleText = styled.div`
  font-weight: 600;
  font-size: 16px;
`;

export const RatingSubtitle = styled.div`
  margin-top: 8px;
  font-size: 14px;
  color: #666;
  line-height: 1.4;
`;

export const StarsContainer = styled.div`
  margin-top: 12px;
  display: flex;
`;

interface StarProps {
  filled?: boolean;
}

export const Star = styled.span<StarProps>`
  font-size: 30px;
  color: ${props => props.filled ? 'gold' : '#ccc'};
  cursor: pointer;
  margin-right: 8px;
  transition: transform 0.1s ease;
  
  &:hover {
    transform: scale(1.1);
  }
`;

export const FeedbackInput = styled.textarea`
  width: 100%;
  margin-top: 12px;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  min-height: 80px;
  font-family: inherit;
  
  &:focus {
    outline: none;
    border-color: #1976d2;
  }
`;

export const FutureCollabContainer = styled.div`
  margin-top: 30px;
  padding: 15px;
  border-radius: 8px;
  background-color: #f0f7ff;
`;

export const FutureCollabTitle = styled.div`
  display: flex;
  align-items: center;
`;

export const EmojiContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-top: 15px;
`;

interface EmojiOptionProps {
  selected?: boolean;
}

export const EmojiOption = styled.div<EmojiOptionProps>`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 32%;
  padding: 10px;
  background-color: ${props => props.selected ? '#e6f7ff' : 'white'};
  border: 1px solid ${props => props.selected ? '#1976d2' : '#ddd'};
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s ease;
  
  &:hover {
    background-color: ${props => props.selected ? '#e6f7ff' : '#f5f5f5'};
  }
`;

export const Emoji = styled.span`
  font-size: 24px;
  margin-bottom: 8px;
  margin-right: 0;
`;

export const EmojiLabel = styled.span`
  font-size: 12px;
  text-align: center;
`;

export const ButtonsContainer = styled.div`
  margin-top: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 30px;
`;

export const PrimaryButton = styled.button`
  width: 100%;
  padding: 12px 24px;
  background-color: ${props => props.disabled ? '#ccc' : '#2e5cb8'};
  color: white;
  border: none;
  border-radius: 4px;
  font-size: 16px;
  font-weight: 500;
  cursor: ${props => props.disabled ? 'not-allowed' : 'pointer'};
  transition: background-color 0.2s ease;
  
  &:hover {
    background-color: ${props => props.disabled ? '#ccc' : '#1565c0'};
  }
`;

export const SecondaryButton = styled.button`
  padding: 8px 0;
  background-color: transparent;
  border: none;
  color: #2e5cb8;
  font-size: 14px;
  font-weight: normal;
  margin-top: 15px;
  cursor: pointer;
  
  &:hover {
    text-decoration: underline;
  }
`; 